import React, {useState, useEffect} from 'react'
import './TaskModelNote.scss'
import _ from 'lodash'

const TaskModelNote = props => {
    const ingest = (data) => {
        return {
            "top":data.top || data.y || 0,
            "left":data.left || data.x || 0,
        }
    }
    
    //current note position
    const [position, setPosition] = useState(ingest(props.data.position));
    //mouse position from top left corner at start of drag
    const [offset, setOffset] = useState({top:0, left:0});
    const [dragging, setDragging] = useState(false);
    const [taskBounds, setTaskBounds] = useState(undefined);

    useEffect(
        ()=> {setPosition(ingest(props.data.position));}, [props.data.position]
    )

   useEffect(()=>{
       setTimeout(()=> {
        // if(taskBounds === undefined){
        const task = document.querySelector('.TaskModel .Screen');
        const bounds = task.getBoundingClientRect();
        setTaskBounds(bounds) 
        return;
        // }
       }, 50)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [window.innerWidth])

    const onDragStart = (e) => {
        //get offset
        if(taskBounds === undefined) return;
        if(dragging) return;

        const note = document.querySelector('.draggable-note');
        const bounds = note.getBoundingClientRect();
        setOffset({
            top:e.clientY - bounds.top,
            left:e.clientX - bounds.left
        })
        setDragging(true)        
    }

    const onDragEnd = (e) => {
        setDragging(false)
    }

    const onDragMove = (e) => {
        //move to mouse position + offset
        
        if(!dragging) return;

        let left = e.clientX - taskBounds.left - offset.left;
        if(left < 0) left = 0;
        if(left > taskBounds.right - taskBounds.left - 280) left = taskBounds.right - taskBounds.left - 280;

        let top = e.clientY - taskBounds.top - offset.top;
        if(top < 0) top = 0;
        if(top > taskBounds.bottom - taskBounds.top - 100) top = taskBounds.bottom - taskBounds.top - 100;
        setPosition({
            "top": top,
            "left": left
        })
    }

    return (
        <div className={`TaskModelNote`}>
            {dragging && <div className={`drag-listener`} style={{
                position:'absolute',
                top:0,
                left:0,
                width:'100%',
                height:'100%',
            }} onMouseMove={onDragMove} 
            onTouchMove={onDragMove}
            onMouseUp={onDragEnd}
            onTouchEnd={onDragEnd}></div>}
            
            <div className={`note-body orange-gradient draggable-note ${dragging ? 'dragging' : 'not-dragging'}`} 
            onMouseDown={onDragStart}
            onTouchStart={onDragStart}
            style={_.merge(_.clone(position), {
                pointerEvents:`${dragging ? 'none' : 'all'}`
            })}>
                <h1>Step {props.stepIndex + 1}</h1>
                <div className={`text`} dangerouslySetInnerHTML={{__html:props.data.content}}></div>
            </div>
        </div>
    )
}

export default TaskModelNote